export default __webpack_public_path__ + "static/media/Quiken_Suministros.c3722de6.png";